export default {
  INIT_STATE: "member/INIT_STATE",
  GET_PROFILE_RESPONSE: "member/GET_PROFILE_RESPONSE",
  GET_MY_BOOKINGS_RESPONSE: "member/GET_MY_BOOKINGS_RESPONSE",
  GET_EMPLOYEE_INFO_RESPONSE: "member/GET_EMPLOYEE_INFO_RESPONSE",
}